export default {"src":"/_next/static/media/Full Bedframe.3afbf186.svg","height":59,"width":108};